module.exports = __webpack_public_path__ + "r-v3/img/doc_down.04e86aca.svg";